import Component from '../abstracts/Component';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
import FixBody from '../utils/FixBody';
import ajaxAction from '../utils/ajaxUtil';
import TrackingComponent from '../components/TrackingComponent';
import PriceRangeComponent from '../components/PriceRangeComponent';
import SaleRangeComponent from '../components/SaleRangeComponent';
import {getFocusElement, hasFocusElement} from '../utils/BrowserHistoryUtils';
import ProductCardSwatchesComponent from './ProductCardSwatchesComponent';

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      titleFilterCounter: '[data-title-counter]',
      filtersButton: '[data-trigger-filters]',
      filtersContainer: '[data-filters-container]',
      filtersContent: '[data-filters-content]',
      sortBy: '[data-sortby]',
      toggleSortDropdown: '[data-sort]',
      sortDropdown: '[data-filter-dropdown]',
      listItems: '[data-filters-item]',
      listItemActive: '[data-filters-item].active',
      liveSubItem: '[data-item-parent-name].live',
      subListPanel: '[data-sublist-container]',
      closeBtn: '[data-trigger-close]',
      closeBtnMobile: '[data-trigger-close-mobile]',
      ctaClear: '[data-cta-clear]',
      ctaView: '[data-cta-view]',
      benefitBar: '[data-benefit-bar]',
      itemText: '[data-item-text]',
      sublistTitle: '[data-sublist-title]',
      sublistText: '[data-sublist-text]',
      productsContainer: '[data-products-container]',
      listingHead: '[data-listing-head]',
      //END WIP
      allFiltersInputs: '.filter-checkbox input[type=checkbox]',
      filtersInputs: '[data-filter-input]:not([name="rangePriceFilter"])',
      priceFilterInputs: 'input[name="rangePriceFilter"]',
      filterSortBy: '[data-filter-sortby]',
      inputs: '.w-f__sublist__item input[type="checkbox"]',
      priceMobileInputs: '[data-mobile-price-filter] input',
      priceMobileContainer: '.w-f__sublist.price-mobile',
      mobileResultsCount: '[data-mobile-results-count]',
      mobileResultsCount2: '[data-mobile-filters-results-count]',
      searchResultsCount: '[data-results-count]',
      saleRangeMobileInputs: '[data-mobile-sale-range-filter] input',
      saleRangeMobileContainer: '.w-f__sublist.sale-range-mobile',
      removeFilters: '.remove-filters',
      removeFiltersEmptySearch: '[data-empty-search]',
      filters: '.w-filters',
      priceFilter: '.price-range'
    };
  }

  get CLASSES() {
    return {
      hidden: '--hidden'
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    // Remove hidden on w-filters when search results are empty
    let queryString = document.location.search;
    let filters = document.querySelectorAll(this.SELECTORS.filters);
    if(queryString.indexOf('isRefineSearch') !== -1 && $(filters).hasClass('--hidden')){
      $(filters).removeClass('--hidden');
    }
    this.selectedFiltersCount = 0; // Contatore dei filtri selezionati
    //this.updateFiltersCounter = this.updateFiltersCounter.bind(this);
    this.updateFilterCounter();
    this.listItems = this.$component.querySelectorAll(this.SELECTORS.listItems);
    this.subListPanel = this.$component.querySelector(
      this.SELECTORS.subListPanel
    );
    this.triggerBtn = this.$component.querySelector(
      this.SELECTORS.filtersButton
    );
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.closeBtnMobile = this.$component.querySelector(
      this.SELECTORS.closeBtnMobile
    );
    this.filtersContainer = this.$component.querySelector(
      this.SELECTORS.filtersContainer
    );
    this.ctaClear = this.$component.querySelector(this.SELECTORS.ctaClear);
    this.ctaView = this.$component.querySelector(this.SELECTORS.ctaView);
    this.content = this.$component.querySelector(this.SELECTORS.filtersContent);
    if(this.content != null && this.content !== 'undefined') {
      this.contentHeight = this.content.offsetHeight;
    }
    this.closeFilters = this.closeFilters.bind(this);
    this.toggleSortDropdown = this.$component.querySelector(this.SELECTORS.toggleSortDropdown);
    this.sortDropdown = this.$component.querySelector(this.SELECTORS.sortDropdown);
    // END WIP
    this.filtersInputs = document.querySelectorAll(this.SELECTORS.filtersInputs);
    this.filterSortBy = document.querySelector(this.SELECTORS.filterSortBy);
    this.sortBy = this.$component.querySelectorAll(this.SELECTORS.sortBy);
    this.productsContainer = document.querySelector(this.SELECTORS.productsContainer);
    this.removeFilters = document.querySelector(this.SELECTORS.removeFilters);
    this.removeFiltersEmptySearch = document.querySelector(this.SELECTORS.removeFiltersEmptySearch);
    this.qs = document.querySelector('.search__input-container [data-search-input]') || document.querySelector('[data-search-input]');
    this.mobileResultsCount = document.querySelector(this.SELECTORS.mobileResultsCount);
    this.mobileResultsCount2 = document.querySelector(this.SELECTORS.mobileResultsCount2);
    this.priceMobileContainer = document.querySelector(this.SELECTORS.priceMobileContainer);
    // extra components
    this.trackingComponent = new TrackingComponent();
    this.PriceRangeComponent = new PriceRangeComponent(htmlEl);
    this.SaleRangeComponent = new SaleRangeComponent(htmlEl);
    this.ajaxAction = new ajaxAction();
  }

  bindEvents() {
    let scrollY = 0;

    //check if
    this.triggerBtn.addEventListener('click', () => {
      this.manageFiltersLayer();
    });

    // sorting toggle
    this.toggleSortDropdown.addEventListener('click', (e) => {
      if (this.toggleSortDropdown.classList.contains('open')) {
        if (isMobile(MobileBreakpoint.Max1023)) {
          FixBody.unblock(scrollY);
          this.sortDropdown.classList.remove('open');
        }
        this.toggleSortDropdown.classList.remove('open');
      } else {
        this.toggleSortDropdown.classList.add('open');
        this.sortDropdown.classList.add('open');

        //this.closeFilters(scrollY);

        if (isMobile(MobileBreakpoint.Max1023)) {
          let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
          let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
          scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
          FixBody.block(barHeight);
        }
      }
    });

    // listen to sort
    this.listenSort();

    this.ctaClear.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.resetFilters();
    });

    this.ctaView.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.applyFilters();
    });

    this.closeBtn.addEventListener('click', () => {
      this.closeFilters(scrollY);
    });

    this.closeBtnMobile.addEventListener('click', () => {
      this.closeFilters(scrollY);
    });

    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, ({ event,payload }) => {
      // refresh swatches on products load
      this.refreshSwatches(payload.newProducts);
    });

    this.handleSubnavRender();
    this.handleMenuItemClick();
    this.bindSalesLabel();
    this.bindMobilePrices();
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // Update filters counter
      this.updateFiltersCounter();
      // check if filters are available after filtering
      this.refreshFilters(payload.response);
      if(document.body.classList.contains('t-search')) {
        this.updateSearchResultsCount(payload.response);
      }
      if(isMobile(MobileBreakpoint.Max1023)) {
        this.refreshMobilePrices(payload.response);
        //updates mobile results count
        this.updateMobileResultsCount(payload.response);
      }
      let newQs = payload.query.replace(this.QUERY_PARAMS.base() + '&', '?');
      history.replaceState(null, null, newQs);

      // REWRITE ALGOLIA PARAMS for tracking
      const parser = new DOMParser();
      const parsedRes = parser.parseFromString(payload.res, 'text/html');
      if(parsedRes.querySelector('[data-algolia-query-id]').dataset.algoliaQueryId !== "") {
        document.querySelector('[data-algolia-query-id]').dataset.algoliaQueryId = parsedRes.querySelector('[data-algolia-query-id]').dataset.algoliaQueryId;
        document.querySelector('[data-algolia-index]').dataset.algoliaIndex = parsedRes.querySelector('[data-algolia-index]').dataset.algoliaIndex;
      } else {
        document.querySelector('[data-algolia-query-id]').dataset.algoliaQueryId = "";
        document.querySelector('[data-algolia-index]').dataset.algoliaIndex = "";
      }
    });

    // dom ready
    $(document).ready(() => {
      let $focusElement = $(getFocusElement());
      let handleFocus = hasFocusElement() && $focusElement.length > 0;
      if(handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }
    });
  }

  listenSort() {
    this.sortBy.forEach(singleSort => {
      singleSort.addEventListener('click', e => {
        this.filterQuery(singleSort);
        setTimeout(()=> {
          this.toggleSortDropdown.classList.remove('open');
        }, 200);
      });
    });
  }

  timedOutScrollToElement($element) {
    setTimeout(()=> {
      this.scrollToElement($element);
    }, 500);
  }

  scrollToElement($element) {
    $element.get(0).scrollIntoView({block: 'center', inline: 'nearest', behavior: 'smooth'});
  }

  closeFilters(scrollY) {
    this.filtersContainer.classList.remove('open');
    //this.filtersContainer.style.height = 0;
    if(isMobile(MobileBreakpoint.Max1023))
      FixBody.unblock(scrollY);
  }

  handleMenuItemClick() {
    const listItems = document.querySelectorAll(this.SELECTORS.listItems);
    const cleanActive = () => {
      listItems.forEach(menuItem => {
        menuItem.classList.remove('active');
      });
    };

    const activeItem = (itemIndex, {avoidMobile = false} = {}) => {
      cleanActive();
      listItems.item(itemIndex).classList.add('active');
      this.$emit(this.$customEvents.FILTERS_EVENTS.active, avoidMobile);
    };

    listItems.forEach((listItem, index) => {
      listItem.addEventListener('click', e => {
        if(!e.target.classList.contains('active')) {
          activeItem(index);
        }
      });
    });
  }

  handleSubnavRender() {
    this.$on(
      this.$customEvents.FILTERS_EVENTS.active,
      ({payload: avoidMobile = false}) => {
        const activeItem = document.querySelector(
          this.SELECTORS.listItemActive
        );
        const sublistSelector = `[data-item-parent-name=${
          activeItem.dataset.filtersItem
        }]`;
        const sublistItems = document.querySelector(sublistSelector);
        this.elementEnter(
          sublistItems,
          document.querySelectorAll(this.SELECTORS.liveSubItem)
        );
        if(!avoidMobile && isMobile(MobileBreakpoint.Max1023)) {
          const title = activeItem.querySelector(this.SELECTORS.itemText)
            .innerHTML;
          this.setMobilePanel(title);
        }
      }
    );
  }

  elementEnter(
    elementEnter,
    elementExit,
    {destroy = false, goingOutEffect = 'goingOut'} = {}
  ) {
    /**
     * Hide old menu
     */
    elementExit.forEach(element => {
      if (element && element.classList) {
        element.classList.remove('live');
        element.classList.add(goingOutEffect);
        setTimeout(() => {
          element.classList.remove(goingOutEffect);
          if (destroy) {
            element.remove();
          }
        }, 500);
      }
    });

    /**
     * Show new menu
     */
    if(elementEnter)
      elementEnter.classList.add('live');
  }

  setMobilePanel(title) {
    const subListPanel = document.querySelector(
      this.SELECTORS.subListPanel
    );
    subListPanel.classList.add('open');
    subListPanel.querySelector(
      this.SELECTORS.sublistText
    ).innerHTML = title;
    subListPanel
      .querySelector(this.SELECTORS.sublistTitle)
      .addEventListener('click', () => {
        subListPanel.classList.remove('open');
      });
  }

  //END WIP

  get QUERY_PARAMS() {
    return {
      base: () => {
        if(document.body.classList.contains('t-search')) {
          return '?partial=true&save=false';
        }
        if(document.querySelector('.shortcut__item.selected')) {
          return '?save=false&';
        }
        return '?save=false';
      },
      // on shortcut category
      shortcut: () => {
        let shortcutQuery = '';
        let selectedShortcut = document.querySelector('.shortcut__item.selected');
        if (selectedShortcut) {
          let productsArray = selectedShortcut?.dataset?.products?.split(',');
          if (productsArray) {
            productsArray.forEach((productCode) => {
              if (productCode.length === 13) {
                shortcutQuery += ':code:' + productCode;
              }
            });
          }
        }
        return shortcutQuery;
      },
      pagination: (page) => {
        let paginationQueryBit = '';
        if(page) {
          // currentPage
          paginationQueryBit = '&page=' + page;
        }
        // if not cached
        return paginationQueryBit;
      },
      textSearch: () => {
        // on search page
        if(document.body.classList.contains('t-search')) {
          // other catches
          if(typeof this.qs == 'undefined' || this.qs == null) return;
          if(typeof this.qs.getAttribute('value') != null) {
            let q = this.qs.getAttribute('value');
            let matchString = new RegExp('[^:]*', '');
            let search = q.match(matchString);
            return search[0];
          }
        }
        return '';
      },
      sortBy: (qs = false) => {
        this.sortBy = $(this.SELECTORS.sortBy, '.filter-bar__dropdown');
        // if there is no sort exits
        if(typeof this.sortBy == 'undefined' || this.sortBy == null) return;
        let sort = '';
        // let's cycle the sorts
        this.sortBy.each((index,single_radio) => {
          // if i have checked the checkbox
          if(single_radio.checked === true) {
            sort = single_radio.value;
          }
        });
        // on sale page i dont want it because i already passed it
        if(this.pageSalesFilters != null) {
          return '';
        }

        // return the sort
        if(qs) {
          return '&sort=' + sort + ':';
        } else {
          return ':'+sort;
        }
      },
      priceRange: (isReset) => {
        let priceQuery = this.PriceRangeComponent.buildQuery(isReset);
        return priceQuery;
      },
      saleRange: () => {
        let saleRangeQuery = this.SaleRangeComponent.buildQuery();
        return saleRangeQuery;
      },
      formData: () => {
        // query
        let filterQuery = '';
        let isSales = false;
        // form inputs
        document.querySelectorAll(this.SELECTORS.filtersInputs).forEach(input => {
          if(input.checked) {
            if(input.id.indexOf('inSales') !== -1) {
              isSales = true;
              //tracking
              this.trackingComponent.actions.filterTracking(input.name, input.value);
            }
            filterQuery = filterQuery + ':' + input.name + ':' + input.value;
            //tracking
            this.trackingComponent.actions.filterTracking(input.name, input.value);
            if(isSales === false) {
              filterQuery.replace('inSales:true:', '');
            }
          }
        });

        return filterQuery;
      }

    }
  }

  // build the filters
  buildQuery(page = false, isReset) {
    // get full query
    let fullQuery =
      this.QUERY_PARAMS.base() +
      '&isRefineSearch=true&q=' +
      this.QUERY_PARAMS.textSearch() +
      this.QUERY_PARAMS.sortBy() +
      this.QUERY_PARAMS.shortcut() +
      this.QUERY_PARAMS.priceRange(isReset) +
      this.QUERY_PARAMS.saleRange() +
      this.QUERY_PARAMS.formData() +
      this.QUERY_PARAMS.pagination(page);

    this.log('fullQuery ', fullQuery);
    return fullQuery;
  }

  // filter function
  filterQuery(page, query = '', isReset = false) {
    this.log('launch query');
    if($(page).attr('data-sortby-name') !== undefined) {
      this.trackingComponent.actions.filterTracking(page, true);
    } else {
      this.trackingComponent.actions.filterTracking(page);
    }
    // build the query
    if(query === '') {
      query = this.buildQuery(query, isReset);
    }
    // main products container
    let productsContainer = this.productsContainer;
    // get the page
    this.getFilteredPage(query).then(res => {
      // render the page
      this.renderPage(res, productsContainer, query, isReset);
      // is priceFilter present
      if (document.querySelector('.noUi-handle-lower') != null
        && document.querySelector('#currentSliderMinValue') != null) {
        // read current min, max value
        let currentMinValue = document.querySelector('.noUi-handle-lower').ariaValueNow;
        let currentMaxValue = document.querySelector('.noUi-handle-upper').ariaValueNow;
        // set values in tag
        document.querySelector('#currentSliderMinValue').innerHTML = parseInt(currentMinValue);
        document.querySelector('#currentSliderMaxValue').innerHTML = parseInt(currentMaxValue);
      }
    });
  }

  filterQueryPagination(page, query = '') {
    this.log('launch query');
    // build the query
    if (typeof query === 'undefined' || query === ''){
      query = this.buildQuery('', false);
    }
    // build the query
    let filteredQuery = query + '&page=' + (page);
    // main products container
    let productsContainer = this.productsContainer;
    // get the page
    this.getFilteredPage(filteredQuery).then(res => {
      let response = new DOMParser().parseFromString(res, 'text/html');
      // render the page
      this.renderPage(res, productsContainer, filteredQuery);
    });
  }

  // get page via ajax function
  getFilteredPage(query) {
    // get content
    return this.ajaxAction.getPage(query);
  }

  // render results
  renderPage(res, target, query = false, isReset = false) {
    // html response
    let response = new DOMParser().parseFromString(res, 'text/html');
    // render content
    this.ajaxAction.renderContent(res, 'products');
    this.renderPagination(res, 'sales-pagination');
    if (isReset) {
      this.ajaxAction.renderContent(res, 'filters-list');
      this.ajaxAction.renderContent(res, 'filters-sublist');
      this.ajaxAction.renderContent(res, 'product-count');
      this.renderPagination(res, 'sales-pagination');
      // hide remove filters buttons
      this.removeFilters.classList.add(this.CLASSES.hidden);
      this.removeFiltersEmptySearch.classList.add(this.CLASSES.hidden);
      let newRanger = document.querySelector(this.PriceRangeComponent.SELECTORS.rangerBar);
      // is priceFilter present
      if (newRanger != null) {
        let newSliderLogic = new PriceRangeComponent(newRanger);
        newSliderLogic.renderNewSlider();
      }
      this.handleMenuItemClick();
      this.resetMobilePanel();
      //re-apply event listeners
      this.updateFilterCounter();
      this.bindMobilePrices();
    }
    // emit events
    this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded);
    this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {response: response, res: res, query: query});
    this.trackNewProducts(response);
    // scroll to top
    window.scrollTo(0, 0);
    this.refreshSwatches();
  }

  // apply function
  applyFilters(isReset=false) {
    // creates and launches query
    this.filterQuery(false, '', isReset);
  }

  // reset function
  resetFilters() {
    // cycle desktop inputs
    document.querySelectorAll(this.SELECTORS.filtersInputs).forEach(input => {
      // set every input false
      if(input.checked === true){
        input.checked = false;
      }
    });
    let titleFilterCounterElement = document.querySelectorAll(this.SELECTORS.titleFilterCounter);
    if (titleFilterCounterElement) {
      titleFilterCounterElement.forEach(title => {
        title.textContent= '';
      });
    }
    // reset sliders
    this.PriceRangeComponent.resetSlider();
    // launch void query
    this.filterQuery(false, '', true);
  }

  refreshFilters(response) {
    document.querySelectorAll(this.SELECTORS.filtersInputs).forEach(input => {
      let inputParent = input.parentElement.parentElement;
      if(response.querySelector('#' + CSS.escape(input.id)) == null && !input.checked) {
        inputParent.classList.add('unavailable');
      } else {
        inputParent.classList.remove('unavailable');
      }
    });
    // refresh price filters
    document.querySelectorAll(this.SELECTORS.priceFilterInputs).forEach(input => {
      if(input.checked) {
        if(response.querySelector('#' + CSS.escape(input.id)) != null) {
          response.querySelector('#' + CSS.escape(input.id)).checked = true;
        }
      }
    });
    this.bindSalesLabel();
    this.resetMobilePanel();
  }

  refreshSwatches(newComponents = false) {
    let components = newComponents ? newComponents: document.querySelectorAll('[data-js-component="ProductCardSwatchesComponent"]');
    if(components !=null)
      components.forEach((component)=> {
        const productCardSwatches = new ProductCardSwatchesComponent(component);
        productCardSwatches.render();
      }
    )
  }

  setMobilePrices(input) {
    if(input.checked && input.dataset.value) {
      let range = input.dataset.value.split("|") || ['0',''];
      document.querySelector('.price-range [data-input-min]').value = range[0];
      if(range[1] !== '') {
        document.querySelector('.price-range [data-input-max]').value = range[1];
      }
    } else if(document.querySelector('.price-range [data-input-min]')
      && document.querySelector('.price-range [data-input-max]')) {
      document.querySelector('.price-range [data-input-min]').value = '';
      document.querySelector('.price-range [data-input-max]').value = '';
    }
  }
  // clear the mobile prices given the selected one
  cleanOtherMobilePrices(selectedInput) {
    document.querySelectorAll(this.SELECTORS.priceMobileInputs).forEach(input => {
      if(input.id !== selectedInput.id) {
        input.checked = false;
      }
    });
    this.alignSalesAndNewArrivalMobile();
  }
  // refresh the mobile prices on update filters event
  refreshMobilePrices(response) {
      if(response.querySelector(this.SELECTORS.priceMobileContainer) != null) {
        let newPriceRanges = response.querySelector(this.SELECTORS.priceMobileContainer).innerHTML;
        if(this.priceMobileContainer.innerHTML !== newPriceRanges) {
          this.priceMobileContainer.innerHTML = newPriceRanges;
          this.bindMobilePrices();
          this.alignSalesAndNewArrivalMobile();
        }
      }
  }

  resetMobilePanel() {
    if(this.subListPanel){
      this.subListPanel.classList.remove('open');
    }
  }

  // update mobile products counter
  updateMobileResultsCount(response) {
    let isSearchResultsCount = response.querySelector(this.SELECTORS.searchResultsCount) != null;
    let isMobileResultsCount = response.querySelector(this.SELECTORS.mobileResultsCount) != null;
    if((isSearchResultsCount) || (isMobileResultsCount)) {
      // new count from the ajax response
      let newCount = isSearchResultsCount ? response.querySelector(this.SELECTORS.searchResultsCount).innerHTML : response.querySelector(this.SELECTORS.mobileResultsCount).innerHTML;
      // insert count in mobile layer
      this.mobileResultsCount.innerHTML = newCount;
      this.mobileResultsCount2.innerHTML = newCount;
    }
  }

  updateFilterCounter() {
    document.querySelectorAll(this.SELECTORS.allFiltersInputs).forEach(input => {
      input.addEventListener('click', (e) => {
         if (e.target.matches(this.SELECTORS.filtersInputs))
          this.updateFiltersCounter();
        });
      });
    }

  updateFiltersCounter() {
    const inputs = document.querySelectorAll(this.SELECTORS.allFiltersInputs + ":checked");
    const isPriceFilterActive = document.querySelector(this.SELECTORS.priceFilter)?.classList.contains('c-p-r__max-value-set') || document.querySelector(this.SELECTORS.priceFilter)?.classList.contains('c-p-r__min-value-set');
    let uniqueIds = new Set();
    //remove possible doubles as "inSalesFilterMobile" && "inSales-true" or "newArrivalFilterMobile" && "newArrival-true"
    inputs.forEach(input => {
      let normalizedId = input.id.replace(/(FilterMobile|-true)/g, '');
        //if (uniqueIds.has(normalizedId)) {
        //    console.log("Ho trovato questo doppione:", normalizedId,input.id);
        //} else {
        //  console.log("nuovo:", normalizedId,input.id);
        uniqueIds.add(normalizedId);
        //}
    });
    this.selectedFiltersCount = uniqueIds.size + (isPriceFilterActive ? 1 : 0);

    let titleFilterCounterElements = document.querySelectorAll(this.SELECTORS.titleFilterCounter);
    if (titleFilterCounterElements) {
      if(this.selectedFiltersCount) {
        titleFilterCounterElements.forEach(title => {
          title.textContent = '(' + this.selectedFiltersCount + ')';
        });
      }
      else {
        titleFilterCounterElements.forEach(title => {
          title.textContent = '';
        });
      }
    }
  }

  // bind the mobile click to the desktop filter
  bindMobilePrices() {
    document.querySelectorAll(this.SELECTORS.priceMobileInputs).forEach(input => {
      input.addEventListener('click', (e) => {
        //binds main sales filter
        if(e.target.id === 'inSalesFilterMobile' && document.querySelector('.insales-filter')) {
          document.querySelector('.insales-filter').checked = e.target.checked ? true : false;
          this.PriceRangeComponent.resetSlider();
        } else if (e.target.id === 'newArrivalFilterMobile' && document.querySelector('.newarrival-filter')) {
          document.querySelector('.newarrival-filter').checked = e.target.checked ? true : false;
        } else {
          //sets price range in price slider for main logic
          this.setMobilePrices(input);
          //only one price range can be active
        }
        this.cleanOtherMobilePrices(input);
        this.updateFiltersCounter();
      });
    });
  }

  manageFiltersLayer() {
    let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    let filtersContainer = this.filtersContainer != null ? this.filtersContainer : document.querySelector(this.SELECTORS.filtersContainer);
    if(filtersContainer.classList.contains('open')) {
      this.closeFilters(scrollY);
    } else {
      filtersContainer.classList.add('open');
      if(!isMobile(MobileBreakpoint.Max1023)) {
        filtersContainer.style.height = this.contentHeight + 'px';
        //filtersContainer.style.marginBottom = this.contentHeight + 'px';
        // Close sorting dropdown if filters overlay is open
        if(this.toggleSortDropdown.classList.contains('open')) {
          this.toggleSortDropdown.classList.remove('open');
        }
      } else {
        scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
        FixBody.block(barHeight);
      }
    }
  }

  alignSalesAndNewArrivalMobile() {
    this.alignMobileFilter('#inSalesFilterMobile', '.insales-filter');
    this.alignMobileFilter('#newArrivalFilterMobile', '.newarrival-filter');
  }

  // align filter mobile (fake) and filter desktop triggers
  alignMobileFilter(mobileSelector, mainSelector) {
    const mobileFilter = document.querySelector(mobileSelector);
    const mainFilter = document.querySelector(mainSelector);

    if(mobileFilter && mainFilter) {
      mobileFilter.checked = mainFilter.checked;
    }
  }

  // sales label in mobile
  bindSalesLabel() {
    if(document.querySelector('.sales-label') != null) {
      document.querySelector('.sales-label').addEventListener('click', () => {
        let salesInput = document.querySelector('.insales-filter');
        if(salesInput.checked) {
          salesInput.checked = false;
        } else {
          salesInput.checked = true;
        }
      });
    }
  }
  // update products counter
  updateSearchResultsCount(response) {
    if(response.querySelector(this.SELECTORS.searchResultsCount) != null) {
      let newCount = response.querySelector(this.SELECTORS.searchResultsCount).innerHTML;
      document.querySelector(this.SELECTORS.searchResultsCount).innerHTML = newCount;
    }
  }

  trackNewProducts(response) {
    let newProducts = null;
    const newProductsContainer = response.querySelector('[data-ajax-source="products"]');

    if (newProductsContainer != null) {
      newProducts = newProductsContainer.querySelectorAll('.c-product-card');
    }

    if (newProducts != null) {
      this.trackingComponent.actions.loadMore(newProducts);
    }
  }

  // content replacing function
  renderPagination(res, contentname = false , fallbacks = false ) {
    // response
    const response = new DOMParser ().parseFromString(res, 'text/html');
    // update content
    let source = response.querySelector('[data-ajax-source='+contentname+']');
    let pagination = document.querySelector('[data-ajax-target='+contentname+']');
    if(source) {
      pagination.classList.remove(this.CLASSES.hidden);
      this.ajaxAction.renderContent(res, contentname);
    } else {
      if (pagination){
        pagination.classList.add(this.CLASSES.hidden);
      }
    }
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
